import { Message } from '../message.model';

export type ComparisonType = 'DPDCY' | 'DPSCY' | 'DPPPY' | 'DPSPY';

export type BodyConsolidatedEntries =
  | {
      Tipo_consulta_BD: 'RANGO_MESES';
      mes_inicial: string;
      mes_final: string;
      sector: string;
      sucursal: string;
      comparacion?: ComparisonType;
    }
  | {
      Tipo_consulta_BD: 'RANGO_DIAS';
      fecha_inicial: string;
      fecha_final: string;
      sector: string;
      sucursal: string;
      comparacion?: ComparisonType;
    }
  | {
      Tipo_consulta_BD: 'ANIO_ACTUAL';
      anio_actual: string;
      sector: string;
      sucursal: string;
      comparacion?: ComparisonType;
    }
  | {
      Tipo_consulta_BD: 'ANIO_ANTERIOR';
      anio_anterior: string;
      sector: string;
      sucursal: string;
      comparacion?: ComparisonType;
    }
  | {
      Tipo_consulta_BD: 'MES_ACTUAL';
      mes_actual: string;
      sector: string;
      sucursal: string;
      comparacion?: ComparisonType;
    }
  | {
      Tipo_consulta_BD: 'MES_ANTERIOR';
      mes_anterior: string;
      sector: string;
      sucursal: string;
      comparacion?: ComparisonType;
    };


  export interface ResponseConsolidatedEntries {
  column_name: ColumnNameConsolidatedEntries | Message;
}

export interface ColumnNameConsolidatedEntries {
  "public data": DataConsolidatedEntries;
}

export interface DataConsolidatedEntries {
  anio_base:     number;
  anio_anterior: number;
  fechas:        DateConsolidatedEntries[];
  resumen:       SummaryConsolidatedEntries;
}

export interface DateConsolidatedEntries {
  "Periodo Fecha":              string;
  "Periodo Fecha año anterior": string;
  "Día similar/año anterior":   number;
  "Entradas":              number;
  "Comparacion_base":                  string;
  "Comparacion_anterior":             string;
}

export interface SummaryConsolidatedEntries {
  total_visitantes_act: number;
  total_visitantes_com: number;
  diferencia:           number;
  porcentaje:           string;
  indicador:            string;
}



